import type { Booking } from '@/entities/bookings/booking.entity.ts';
import { computed, type ComputedRef, type MaybeRefOrGetter, toValue } from 'vue';
import type { ManyBookingsBooking } from '@/entities/bookings/many-bookings-booking.entity.ts';
import type { ArrayType } from '@/utils/array-type.ts';

export const getAllocationOfBookingByDate = <T extends Booking | ManyBookingsBooking>(
  booking: T,
  date: Date,
): ArrayType<T['allocations']> => {
  return (booking.allocations
    .sort((a, b) => (a.startDate > b.startDate ? 1 : -1))
    .find((a) => new Date(a.endDate) > date) ??
    booking.allocations[booking.allocations.length - 1]) as ArrayType<T['allocations']>;
};

export const useAllocationOfBookingByDate = <T extends Booking | ManyBookingsBooking>(
  booking: MaybeRefOrGetter<T>,
  date: MaybeRefOrGetter<Date>,
): ComputedRef<ArrayType<T['allocations']>> => {
  return computed(() => getAllocationOfBookingByDate(toValue(booking), toValue(date)));
};
